import { memo, useMemo } from "react";

import { useProduct } from "@shopify/hydrogen-react";

import { formatProductVariant } from "@root/tablescape/utilities";
import { getLoyaltyTier } from "@tablescape/utilities/customer";

import { GiftWithPurchaseView } from "./GiftWithPurchase.view";

const GiftWithPurchaseBase = () => {
  const { selectedVariant } = useProduct();

  const selectedGiftWithPurchase = useMemo(
    () => formatProductVariant(selectedVariant).giftWithPurchase,
    [selectedVariant]
  );

  const loyaltyTier = useMemo(getLoyaltyTier, []);

  if (
    !selectedGiftWithPurchase ||
    (loyaltyTier &&
      selectedGiftWithPurchase.eligibleLoyaltyTiers?.includes(loyaltyTier))
  ) {
    return null;
  }

  return (
    <GiftWithPurchaseView
      bannerText={selectedGiftWithPurchase.bannerText}
      description={selectedGiftWithPurchase.description}
      thumbnailUrl={selectedGiftWithPurchase.thumbnailUrl}
      title={selectedGiftWithPurchase.title}
    />
  );
};

export const GiftWithPurchase = memo(GiftWithPurchaseBase);
